export default __webpack_public_path__ + "static/media/pencil.db709f54.png";